// Copyright (c) 2016 Deere & Company

import PipClaimContainer from '../../claim/pip/state-connector';

export default {
    component: PipClaimContainer,
    name: 'PIP',
    path: 'pip/edit/:claimNumber'
};



// WEBPACK FOOTER //
// ./src/routes/claims/edit-pip-claim-route.js